import { ApiTenant } from '@allbin/mobilix-api-client';

export const tdTenants: ApiTenant[] = [
  {
    id: 'region-sormland',
    tenant_id: 'lts',
    name: 'Region Sörmland',
  },
  {
    id: 'region-vastmanland',
    tenant_id: 'vl',
    name: 'Region Västmanland',
  },
];
